import { Effect, Layer, Schema } from "effect";
import { QueryWork } from "../state/query-work.ts";
import { EditorHighlightRequest, EditorHighlightInputFailure, editorHighlightDependencyFailure, languageForFile } from "./highlight-model.ts";
import { EditorHighlightIo, EditorHighlights } from "./highlight-service.ts";

export const EditorHighlightsLive = Layer.effect(EditorHighlights, Effect.gen(function* () {
  const io = yield* EditorHighlightIo;
  const queries = yield* QueryWork;
  return EditorHighlights.of({
    render: Effect.fn("Frontend.EditorHighlights.render")(function* (request) {
      const input = yield* Schema.decodeUnknownEffect(EditorHighlightRequest)(request).pipe(Effect.mapError(() => new EditorHighlightInputFailure()));
      // Monaco tokenization cannot abort. Join admitted work before query/root
      // closure; an interrupted observer cannot publish its eventual result.
      return yield* queries.observe(Effect.gen(function* () {
        const raw = yield* io.colorize(input.text, languageForFile(input.file));
        const html = yield* Schema.decodeUnknownEffect(Schema.String)(raw).pipe(Effect.mapError(editorHighlightDependencyFailure));
        return html.replace(/<br\s*\/?>/g, "");
      }).pipe(Effect.uninterruptible));
    })
  });
}));
